import { createFileRoute, redirect } from '@tanstack/react-router';

// Trash opens on its Files tab (CUR-1232 split the page into Files and Registers).
export const Route = createFileRoute('/console/$orgId/configuration/org-settings/trash/')({
    beforeLoad: ({ params }): never => {
        throw redirect({
            to: '/console/$orgId/configuration/org-settings/trash/files',
            params,
            replace: true,
        });
    },
});
